export default __webpack_public_path__ + "static/media/Zuculini.3b5d7605.jpg";